import { Outlet } from 'react-router-dom';

import { useMe } from 'entities/Auth/sdk';

import SideNavigation from 'components/SideNavigation';
import TopNavigation from 'components/TopNavigation';

const MainLayout = () => {
  const { data: me } = useMe();
  return (
    <div className="flex h-screen w-full overflow-hidden">
      {me && (
        <aside className="hidden w-40 shrink-0 border-r bg-white md:block">
          <SideNavigation />
        </aside>
      )}

      <div className="flex flex-1 flex-col overflow-hidden">
        <TopNavigation />
        <div className="flex-1 overflow-auto bg-gray-50">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
